// extracted by mini-css-extract-plugin
export default {"pageLoading":"PageLoading_pageLoading__pTvyH","spinnerBorder":"PageLoading_spinnerBorder__HhkJV","spinner-border":"PageLoading_spinner-border__j8PsB"};